// CheticampInformation.jsx
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MKBox from "components/MKBox";
import PropTypes from "prop-types"


import { useState } from "react";
import {
  Dialog,
} from "@mui/material";


const ResponsiveImage = ({ src, alt }) => {
  

const [open, setOpen] = useState(false);

  return (
    <>
      <Box
        component="img"
        src={src}
        alt={alt}
        onClick={() => setOpen(true)}
        sx={{
          width: "100%",
          maxWidth: 600,
          height: "auto",
          mx: "auto",
          my: 3,
          display: "block",
          cursor: "zoom-in",
          borderRadius: 2,
        }}
      />

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
        <Box
          component="img"
          src={src}
          alt={alt}
          sx={{
            width: "100%",
            height: "auto",
          }}
        />
      </Dialog>
    </>
  );
};




ResponsiveImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

function CheticampInformation() {


  return (
    <MKBox component="section" py={{ xs: 6, md: 10 }}>
      <Container maxWidth="lg">
        <Typography variant="h3" mb={3}>
          Chéticamp-Margarees-Pleasant Bay By-election
        </Typography>
        <ResponsiveImage src="/img/website image 1.jpg" alt="Electoral district map" />

        <Typography mb={4}>
          The Chief Electoral Officer (CEO) received an order from the Governor in Council on Sunday, May 24, 2026, for a by-election in the new electoral district of Chéticamp-Margarees-Pleasant Bay. The CEO issued a writ of election for Chéticamp-Margarees-Pleasant Bay and election day was Tuesday, June 23, 2026.
        </Typography>

        <Typography variant="h4" mb={2}>
          Chéticamp-Margarees-Pleasant Bay By-election Official Results
        </Typography>
        <Typography>
          The official results for the Chéticamp-Margarees-Pleasant Bay by-election are available live at the following <u><b><a href = "https://results.electionsnovascotia.ca/By-election_Multi.aspx">link</a></b></u>
        </Typography>
         <br/>

        <Box mb={8}>
          <Typography variant="h4" mb={2}>Chéticamp-Margarees-Pleasant Bay By-election Expenses</Typography>      
          <Typography>
            <ul style={{ paddingLeft: "40px" }}>
                  <li><a href="/files/Chéticamp-Margarees-Pleasant Bay By-election/Expenses/2026_Chéticamp-Margarees-Pleasant Bay_PC_Bourgeois, Claude_Expenses.pdf">Claude Bourgeois (PC) Expenses</a> (PDF)</li>
            </ul>
          </Typography>
        </Box>

        <Box mb={8}>
          <Typography variant="h4" mb={2}>Candidate and Party Spending Limits for the Chéticamp-Margarees-Pleasant Bay by-election</Typography>      
          <Typography>
            The following amounts are determined according to the Elections Act (updated to include CPI adjustments):
            <br/><br/>
            <b>Final Number of Electors: 4,002 (as of July 27, 2026)</b>
            <br/>
            <b>Candidate Spending Limit*: $32,343.47</b>
            <br/>
            <b>Candidate Reimbursement Limit: $8,085.87</b>
            <br/>
            <b>Registered Party Spending Limit: $8,086.35</b>
            <br/>
            <b>Third Party Spending Limit: $2,825.81</b>
            <br/><br/>
          <i>*The candidate spending limit for the Chéticamp-Margarees-Pleasant Bay by-election has been adjusted based on the number of electors on the Final List of Electors as of July 27, 2026.</i> <br/>
          </Typography>
        </Box>

        <Box mb={8}>
          <Typography variant="h4" mb={2}>Financial Reporting Deadlines for the Chéticamp-Margarees-Pleasant Bay by-election</Typography>
          <Typography>
            Financial reports from the candidates, registered political parties, and third party advertisers, are due in the weeks and months ahead. All reports must be sent to the Chief Electoral Officer.
            <br/>
            Candidate tax receipts are due 30 days after election day on July 23, 2026.
            <br/>
            Candidate financial reports, including audit reports, are due (80 days after writ) on September 21, 2026.
            <br/>
            It is also important to remember that there are fines of $50 per day for late candidate reports.
            <br/>
            Registered party financial reports are due (120 days after Writ) on October 31, 2026.
            <br/>
            Third party election advertising reports are due on October 23, 2026.
          </Typography>
        </Box>

        <Box mb={8}>
          <Typography variant="h4" mb={2}>New Electoral Boundary</Typography>
          <Typography>
            Legislation was introduced in February 2026 to create a new exceptional electoral district called Chéticamp-Margarees-Pleasant Bay out of the existing Inverness electoral district. Amendments to the <a href = "https://nslegislature.ca/sites/default/files/legc/statutes/house%20of%20assembly.pdf">House of Assembly Act</a> implement the recommendations of the <a href ="https://www.nselectoralboundariescommission2025.ca/">2025 Electoral Boundaries Commission</a>, which released its final report January 30, 2026.
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Nouvelle délimitation</Typography>
          <Typography>
            Une loi a été introduite en février 2026 afin de créer une nouvelle circonscription électorale exceptionnelle, appelée Chéticamp-Margarees-Pleasant Bay, pour remplacer la circonscription d’Inverness. Les modifications apportées à la loi sur la Chambre d’assemblée  <a href = "https://nslegislature.ca/sites/default/files/legc/statutes/house%20of%20assembly.pdf">(House of Assembly Act)</a> visent à mettre en œuvre les recommandations de la  <a href ="https://www.nselectoralboundariescommission2025.ca/">Commission de délimitation des circonscriptions électorales de 2025</a>, qui a publié son rapport final le 30 janvier 2026.
          </Typography>
        </Box>

        <Box mb={8}>
          <Typography variant="h4" mb={2}>Know Your Electoral District</Typography>
          <Typography>
            Residents of Chéticamp-Margarees-Pleasant Bay are encouraged to use the following links to connect with information and maps of their new exceptional electoral district.
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Apprenez à connaître votre circonscription électorale</Typography>
          <Typography>
            Nous invitons les habitants de Chéticamp-Margarees-Pleasant Bay à cliquer sur les liens suivants pour obtenir des informations et consulter les cartes de leur nouvelle circonscription électorale. Ces ressources sont disponibles uniquement en anglais.
          </Typography>
          <br/>
          <Typography>
              <ul>Click here to view an <a href ="https://enstools.electionsnovascotia.ca/edinfo/"> electoral profile.</a></ul>
              <ul>Click here to view the <a href ="https://electionsnovascotia.ca/files/GIS/Maps/Ch%C3%A9ticamp-Margarees-Pleasant%20Bay.pdf"> electoral district map.</a></ul>
          </Typography>
        </Box>

        <Box  mb={8}>
          <Typography variant="h4" mb={2}>Chéticamp-Margarees-Pleasant Bay by-election Media Releases</Typography>
          <Typography>
            The following media releases have been issued for the Chéticamp-Margarees-Pleasant Bay by-election: 
            <ul style={{ paddingLeft: "40px" }}>
              <li><a href ="/news">Chéticamp-Margarees-Pleasant Bay by-election Official Addition – June 25, 2026</a></li>
              <li><a href ="/news">Official Addition Tomorrow – June 24, 2026</a></li>
              <li><a href ="/news">Unofficial Results for Chéticamp-Margarees-Pleasant Bay – June 23, 2026</a></li>
              <li><a href ="/news">Voting is Closed for Chéticamp-Margarees-Pleasant Bay by-election – June 23, 2026</a></li>
              <li><a href ="/news">Write-in Ballot Reminder – June 23, 2026</a></li>
              <li><a href ="/news">Election Day Voting has Begun for the Chéticamp-Margarees-Pleasant Bay by-election – June 23, 2026</a></li>
              <li><a href ="/news">Tomorrow is Election Day in Chéticamp-Margarees-Pleasant Bay – June 22, 2026</a></li>
              <li><a href ="/news">Early Voting Available Today for the Chéticamp-Margarees-Pleasant Bay by-election – June 22, 2026</a></li>
              <li><a href ="/news">Chéticamp-Margarees-Pleasant Bay By-election Reminders – June 19, 2026</a></li>
              <li><a href ="/news">Extended hours for Early Voting in the Chéticamp-Margarees-Pleasant Bay by-election – June 18, 2026</a></li>
              <li><a href ="/news">Voters in Chéticamp-Margarees-Pleasant Bay are Reminded to Bring Their VIC When They Vote – June 17, 2026</a></li>
              <li><a href ="/news">One Week Remaining in the Chéticamp-Margarees-Pleasant Bay By-election – June 16, 2026</a></li>
              <li><a href ="/news">Chéticamp-Margarees-Pleasant Bay By-election Information – June 15, 2026</a></li>
              <li><a href ="/news">Bring ID When You Vote in the Chéticamp-Margarees-Pleasant Bay by-election – June 12, 2026</a></li>
              <li><a href ="/news">Community Polls Open for Early Voting in the Chéticamp-Margarees-Pleasant Bay By-election – June 11, 2026</a></li>
              <li><a href ="/news">Voter Information Cards (VIC) for the Chéticamp-Margarees-Pleasant Bay By-election – June 10, 2026</a></li>
              <li><a href ="/news">Community Polls for the Chéticamp-Margarees-Pleasant Bay By-election Begin Tomorrow – June 10, 2026</a></li>
              <li><a href ="/news">Vote Remotely in the Chéticamp-Margarees-Pleasant Bay By-election – June 9, 2026</a></li>
              <li><a href ="/news">Early Voting Opportunities This Week In Chéticamp-Margarees-Pleasant Bay – June 9, 2026</a></li>
              <li><a href ="/news">Voters in Chéticamp-Margarees-Pleasant Bay should watch their mailboxes this week for their Voter Information Card (VIC) – June 8, 2026</a></li>
              <li><a href ="/news">Voting Options for the Chéticamp-Margarees-Pleasant Bay by-election – June 5, 2026</a></li>
              <li><a href ="/news">Chéticamp-Margarees-Pleasant Bay Voters Can Apply to Vote Remotely – June 5, 2026</a></li>
              <li><a href ="/news">Voter Information Cards (VIC) are in the Mail for the Chéticamp-Margarees-Pleasant Bay by-election – June 4, 2026</a></li>
              <li><a href ="/news">e-Balloting begins in the Chéticamp-Margarees-Pleasant Bay by-election – June 4, 2026</a></li>
              <li><a href ="/news">Nominations Closed for the Chéticamp-Margarees-Pleasant Bay by-election – June 3, 2026</a></li>
              <li><a href ="/news">E-Balloting will Begin Tomorrow in the Chéticamp-Margarees-Pleasant Bay by-election – June 3, 2026</a></li>
              <li><a href ="/news">Candidate Nominations for the Chéticamp-Margarees-Pleasant Bay by-election Close Tomorrow – June 2, 2026</a></li>
              <li><a href ="/news">Call for Election Workers in Chéticamp-Margarees-Pleasant Bay – June 2, 2026</a></li>
              <li><a href ="/news">Voting Information for the Chéticamp-Margarees-Pleasant Bay by-election – June 1, 2026</a></li>
              <li><a href ="/news">Candidate Nominations for the Chéticamp-Margarees-Pleasant Bay by-election – June 1, 2026</a></li>
              <li><a href ="/news">Campaign Access to Multi-unit Buildings – May 29, 2026</a></li>
              <li><a href ="/news">Campaign Signage and Election Advertising – May 29, 2026</a></li>
              <li><a href ="/news">Remote Voting by Write-in Ballot in the Chéticamp-Margarees-Pleasant Bay By-election – May 28, 2026</a></li>
              <li><a href ="/news">Call for Election Workers in Chéticamp-Margarees-Pleasant Bay – May 27, 2026</a></li>
              <li><a href ="/news">Eligible Voters Encouraged to Register for the Chéticamp-Margarees-Pleasant Bay by-election – May 27, 2026</a></li>
              <li><a href ="/news">Early Voting Has Begun Ahead of Schedule for the Chéticamp-Margarees-Pleasant Bay By-election – May 26, 2026</a></li>
              <li><a href ="/news">Candidate and Party Spending Limits for the Chéticamp-Margarees-Pleasant Bay by-election – May 26, 2026</a></li>
              <li><a href ="/news">Candidate Nomination Fee Not Required for the Chéticamp-Margarees-Pleasant Bay by-election – May 25, 2026</a></li>
              <li><a href ="/news">Chéticamp-Margarees-Pleasant Bay by-election – May 25, 2026</a></li>
              <li><a href ="/news">Chéticamp-Margarees-Pleasant Bay by-election Called – May 24, 2026</a></li>
              <li><a href = "/news">Elections That Work For You – May 24, 2026 </a></li>        
            </ul>
            </Typography>
        </Box>       
      </Container>
    </MKBox>
  );
}

export default CheticampInformation;
